"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NumberHelper {
    constructor(value) {
        this.finalValue = 0;
        this.initValue = value;
        this.finalValue = value;
    }
    addPercent(value) {
        const percent = (value / 100) * this.finalValue;
        const newValue = Number((this.finalValue + percent).toFixed(2));
        this.finalValue = newValue;
        return this;
    }
    subtractPercent(value) {
        const newValue = this.finalValue * (100 / (100 + value));
        this.finalValue = Number(newValue.toFixed(2));
        return this;
    }
    addValue(value) {
        const newValue = this.finalValue + value;
        this.finalValue = newValue;
        return this;
    }
    withDays(days) {
        const newValue = Number((this.finalValue * days).toFixed(2));
        this.finalValue = newValue;
        return this;
    }
    multiply(value) {
        this.withDays(value);
        return this;
    }
    divide(value) {
        const newValue = Number((this.finalValue / value).toFixed(2));
        this.finalValue = newValue;
        return this;
    }
    withoutDays(days) {
        const newValue = Number((this.finalValue / days).toFixed(2));
        this.finalValue = newValue;
        return this;
    }
    get value() {
        return this.finalValue;
    }
}
exports.default = NumberHelper;
//# sourceMappingURL=number.js.map